import { render } from "./ClientLogos.vue?vue&type=template&id=2834c991"
import script from "./ClientLogos.vue?vue&type=script&lang=js"
export * from "./ClientLogos.vue?vue&type=script&lang=js"

import "./ClientLogos.vue?vue&type=style&index=0&id=2834c991&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__